
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quelle est la technique utilisée?`}</em></p>
    <p>{`Ce produit est à
`}<a parentName="p" {...{
        "href": "https://ofsp-coronavirus.ch/vaccination/comment-fonctionne-la-vaccination/"
      }}>{`vecteur viral`}</a>{`,
comme celui d’AstraZeneca. Le vaccin contient bien un virus, mais pas celui
qu’on penserait: il s’agit d’un adénovirus humain qui a été transformé pour ne
plus se répliquer et être inoffensif. On y a aussi intégré un bout d’ADN du
Sars-Cov-2. Le vecteur délivre cet ADN dans le noyau de nos cellules, qui le
transcrivent en ARN messager. Cet ARN donne à son tour l’instruction de produire
une protéine du coronavirus, contre laquelle nous allons développer des
anticorps.`}</p>
    <p><strong parentName="p">{`Note sur les adénovirus: Les adénovirus sont une famille comptant une centaine
de virus, dont une quarantaine environ peut infecter l’homme. En général, les
infections ne se remarquent pas ou sont bénignes. Ils causent surtout des
maladies respiratoires, mais aussi la conjonctivite.`}</strong></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;